import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/header/header";
import Landing from "./components/landing/landing";
import Preview from "./components/preview/preview";
import Footer from "./components/footer/footer";
import Legal from "./components/legal/legal";
import Contact from "./components/contact/contact";
import Studio516 from "./components/Studio516/studio516";
import Appartment407 from "./components/Appartment407/appartment407";
import NotFound from "./components/NotFound/NotFound";
import { trackPageView } from "./utils/analytics";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Track page view in Google Analytics
    trackPageView(pathname, document.title);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Landing />
              <Preview />
            </>
          }
        />
        <Route
          path="/studio-516-2-etoiles-chatel-guyon"
          element={<Studio516 />}
        />
        <Route
          path="/appartement-407-4-etoiles-chatel-guyon"
          element={<Appartment407 />}
        />
        <Route path="/legal" element={<Legal />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
